// extracted by mini-css-extract-plugin
export default {"container":"_3UzkJHveVvrWcC2odS54Wg==","lottie":"ITHQs4GIOw7yq16fTIGB4w=="};